import React, { useState, useEffect } from "react";
import { NavLink } from "react-router-dom";

const cardStyle = {
  background: "#ffffff",
  borderRadius: "8px",
  boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
  padding: "20px",
  marginBottom: "20px",
};

const accentColor = "#06d1c6";

const SAMPLE_KYC = [
  {
    id: 1,
    dateOfSubmission: "02-02-2026 12:24 PM",
    clientName: "HARSHIL ATULKUMAR BHAVSAR",
    pan: "FMHPB8293Q",
    emailId: "bhavsarharshil2001@gmail.com",
    mobile: "9687204385",
    status: "DRAFT",
    rejectionReason: "",
    applicationType: "New",
    comments: "",
  },
  {
    id: 2,
    dateOfSubmission: "02-02-2026 12:22 PM",
    clientName: "HARSHIL ATULKUMAR BHAVSAR",
    pan: "FMHPB8293Q",
    emailId: "bhavsarharshil2001@gmail.com",
    mobile: "9687204385",
    status: "DRAFT",
    rejectionReason: "",
    applicationType: "New",
    comments: "",
  },
];

const COLUMNS = [
  { key: "dateOfSubmission", label: "Date of Submission", searchIcon: false },
  { key: "clientName", label: "Client Name", searchIcon: true },
  { key: "pan", label: "PAN", searchIcon: true },
  { key: "emailId", label: "Email ID", searchIcon: true },
  { key: "mobile", label: "Mobile", searchIcon: true },
  { key: "status", label: "Status", searchIcon: true },
  { key: "rejectionReason", label: "Rejection Reason", searchIcon: false },
  { key: "applicationType", label: "Application Type", searchIcon: false },
  { key: "comments", label: "Comments", searchIcon: false },
];

export default function KycStatusReport() {
  const [dateFrom, setDateFrom] = useState("17-01-2026");
  const [dateTo, setDateTo] = useState("16-02-2026");
  const [sortBy, setSortBy] = useState("dateOfSubmission");
  const [sortDir, setSortDir] = useState("desc");
  const [rowsPerPage, setRowsPerPage] = useState(2);
  const [currentPage, setCurrentPage] = useState(1);

  // Generate Video KYC modal
  const [showGenerateKycModal, setShowGenerateKycModal] = useState(false);
  const [modalName, setModalName] = useState("");
  const [modalPan, setModalPan] = useState("");
  const [modalMobile, setModalMobile] = useState("");
  const [modalEmail, setModalEmail] = useState("");
  const [modalApplicationStatus, setModalApplicationStatus] = useState("new"); // "new" | "modified"

  const openGenerateKycModal = () => {
    setModalName("");
    setModalPan("");
    setModalMobile("");
    setModalEmail("");
    setModalApplicationStatus("new");
    setShowGenerateKycModal(true);
  };

  const closeGenerateKycModal = () => setShowGenerateKycModal(false);

  const handleDoKyc = (e) => {
    e.preventDefault();
    // TODO: API - generate video KYC
    console.log({
      name: modalName,
      pan: modalPan,
      mobile: modalMobile,
      email: modalEmail,
      applicationStatus: modalApplicationStatus,
    });
    closeGenerateKycModal();
  };

  useEffect(() => {
    if (!showGenerateKycModal) return;
    const onEscape = (e) => {
      if (e.key === "Escape") closeGenerateKycModal();
    };
    document.addEventListener("keydown", onEscape);
    document.body.style.overflow = "hidden";
    return () => {
      document.removeEventListener("keydown", onEscape);
      document.body.style.overflow = "";
    };
  }, [showGenerateKycModal]);

  const modalInputStyle = {
    width: "100%",
    padding: "8px 12px",
    border: `1px solid ${accentColor}`,
    borderRadius: "6px",
    backgroundColor: "#fff",
    color: "#334155",
    fontSize: "14px",
  };

  const toggleSort = (key) => {
    if (sortBy === key) setSortDir((d) => (d === "asc" ? "desc" : "asc"));
    else {
      setSortBy(key);
      setSortDir("desc");
    }
  };

  const SortIcon = ({ columnKey }) => (
    <button
      type="button"
      className="btn btn-link p-0 ms-1 border-0"
      style={{
        color: sortBy === columnKey ? accentColor : "#64748b",
        fontSize: "11px",
      }}
      onClick={() => toggleSort(columnKey)}
      aria-label={`Sort by ${columnKey}`}
    >
      <i
        className={`fa fa-sort-${sortBy === columnKey ? (sortDir === "asc" ? "up" : "down") : "up"}`}
        style={{ opacity: sortBy === columnKey ? 1 : 0.4 }}
      />
    </button>
  );

  const totalRows = SAMPLE_KYC.length;
  const startRow = (currentPage - 1) * rowsPerPage;
  const paginatedRows = SAMPLE_KYC.slice(startRow, startRow + rowsPerPage);

  return (
    <div className="main-content">
      <div className="page-wrapper page-settings">
        <div className="content">
          {/* Breadcrumb and Header */}
          <div className="mb-4" style={cardStyle}>
            <div className="content-page-header content-page-headersplit">
              <h5>KYC Status Report</h5>
            </div>
            <nav aria-label="breadcrumb" style={{ "--bs-breadcrumb-divider": "none", marginBottom: "15px" }}>
              <ol className="breadcrumb">
                <li className="breadcrumb-item">
                  <NavLink to="/dashboard">Dashboard</NavLink> /
                </li>
                <li className="breadcrumb-item">
                  <NavLink to="/admin/invest-bse/profile-list">Invest Online BSE</NavLink> /
                </li>
                <li className="breadcrumb-item active" aria-current="page">
                  KYC Status Report
                </li>
              </ol>
            </nav>
          </div>

          {/* Top bar: Generate KYC + Date range + Export */}
          <div style={cardStyle}>
            <div className="d-flex flex-wrap align-items-center justify-content-between gap-3">
              <div className="d-flex flex-wrap align-items-center gap-3">
                <button
                  type="button"
                  onClick={openGenerateKycModal}
                  style={{
                    background: "#10b981",
                    color: "#fff",
                    border: "none",
                    padding: "8px 18px",
                    borderRadius: "6px",
                    fontWeight: 600,
                    fontSize: "14px",
                    cursor: "pointer",
                  }}
                >
                  Generate KYC
                </button>
                <div className="d-flex align-items-center gap-2">
                  <span
                    className="d-flex align-items-center justify-content-center rounded-start"
                    style={{
                      padding: "8px 10px",
                      border: "1px solid #e2e8f0",
                      borderRight: "none",
                      backgroundColor: "#fff",
                      color: "#64748b",
                    }}
                  >
                    <i className="fa fa-calendar-alt" />
                  </span>
                  <input
                    type="text"
                    value={dateFrom}
                    onChange={(e) => setDateFrom(e.target.value)}
                    placeholder="DD-MM-YYYY"
                    style={{
                      width: 120,
                      padding: "8px 10px",
                      border: "1px solid #e2e8f0",
                      borderTopLeftRadius: 0,
                      borderBottomLeftRadius: 0,
                      fontSize: "14px",
                    }}
                  />
                  <span style={{ color: "#64748b" }}>-</span>
                  <input
                    type="text"
                    value={dateTo}
                    onChange={(e) => setDateTo(e.target.value)}
                    placeholder="DD-MM-YYYY"
                    style={{
                      width: 120,
                      padding: "8px 10px",
                      border: "1px solid #e2e8f0",
                      borderRadius: "6px",
                      fontSize: "14px",
                    }}
                  />
                </div>
              </div>
              <button
                type="button"
                className="d-flex align-items-center justify-content-center"
                style={{
                  width: 44,
                  height: 40,
                  background: "#10b981",
                  color: "#fff",
                  border: "none",
                  borderRadius: "6px",
                  fontSize: "12px",
                  fontWeight: 700,
                  cursor: "pointer",
                }}
                title="Export to Excel"
              >
                <i className="fa fa-file-excel" style={{ fontSize: "18px" }} />
              </button>
            </div>
          </div>

          {/* Table */}
          <div style={{ ...cardStyle, overflowX: "auto", padding: 0 }}>
            <table className="table table-bordered mb-0" style={{ fontSize: "13px" }}>
              <thead>
                <tr style={{ backgroundColor: "#f8fafc" }}>
                  {COLUMNS.map(({ key, label, searchIcon }) => (
                    <th
                      key={key}
                      className="text-nowrap"
                      style={{
                        padding: "10px 12px",
                        fontWeight: 600,
                        color: "#334155",
                        borderBottom:
                          sortBy === key && key === "dateOfSubmission"
                            ? `2px solid ${accentColor}`
                            : undefined,
                      }}
                    >
                      {label}
                      <SortIcon columnKey={key} />
                      {searchIcon && (
                        <i className="fa fa-search ms-1" style={{ fontSize: "11px", color: "#94a3b8" }} />
                      )}
                    </th>
                  ))}
                  <th
                    style={{
                      padding: "10px 12px",
                      fontWeight: 600,
                      color: "#334155",
                      width: 70,
                    }}
                  >
                    Actions
                    <SortIcon columnKey="actions" />
                  </th>
                </tr>
              </thead>
              <tbody>
                {paginatedRows.map((row) => (
                  <tr key={row.id}>
                    <td style={{ padding: "10px 12px" }}>{row.dateOfSubmission}</td>
                    <td style={{ padding: "10px 12px" }}>{row.clientName}</td>
                    <td style={{ padding: "10px 12px" }}>{row.pan}</td>
                    <td style={{ padding: "10px 12px" }}>{row.emailId}</td>
                    <td style={{ padding: "10px 12px" }}>{row.mobile}</td>
                    <td style={{ padding: "10px 12px" }}>{row.status}</td>
                    <td style={{ padding: "10px 12px", color: "#94a3b8" }}>{row.rejectionReason || "-"}</td>
                    <td style={{ padding: "10px 12px" }}>{row.applicationType}</td>
                    <td style={{ padding: "10px 12px", color: "#94a3b8", borderStyle: "dotted" }}>
                      {row.comments || "—"}
                    </td>
                    <td style={{ padding: "10px 12px" }}>
                      <button
                        type="button"
                        className="btn btn-link p-0 text-secondary"
                        aria-label="Actions"
                      >
                        <i className="fa fa-ellipsis-v" />
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>

            {/* Pagination / rows visible */}
            <div
              className="d-flex flex-wrap align-items-center justify-content-between gap-2 px-3 py-2"
              style={{ borderTop: "1px solid #e2e8f0", backgroundColor: "#f8fafc" }}
            >
              <div className="d-flex align-items-center gap-2">
                <select
                  value={rowsPerPage}
                  onChange={(e) => {
                    setRowsPerPage(Number(e.target.value));
                    setCurrentPage(1);
                  }}
                  style={{
                    padding: "4px 8px",
                    border: "1px solid #e2e8f0",
                    borderRadius: "6px",
                    fontSize: "13px",
                  }}
                >
                  <option value={2}>2</option>
                  <option value={5}>5</option>
                  <option value={10}>10</option>
                  <option value={25}>25</option>
                  <option value={50}>50</option>
                </select>
                <span style={{ fontSize: "13px", color: "#64748b" }}>
                  rows visible out of {totalRows}.
                </span>
              </div>
              <div className="d-flex align-items-center gap-1">
                <button
                  type="button"
                  className="d-flex align-items-center justify-content-center rounded-circle border-0"
                  style={{
                    width: 32,
                    height: 32,
                    background: accentColor,
                    color: "#fff",
                    fontWeight: 700,
                    fontSize: "14px",
                    cursor: "pointer",
                  }}
                  aria-label="Page 1"
                >
                  1
                </button>
              </div>
            </div>
          </div>

          {/* Generate Video KYC Modal */}
          {showGenerateKycModal && (
            <div
              role="dialog"
              aria-modal="true"
              aria-labelledby="generate-video-kyc-title"
              style={{
                position: "fixed",
                inset: 0,
                zIndex: 9999,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                padding: 20,
                background: "rgba(0,0,0,0.4)",
              }}
              onClick={(e) => e.target === e.currentTarget && closeGenerateKycModal()}
            >
              <div
                style={{
                  background: "#fff",
                  borderRadius: "10px",
                  boxShadow: "0 20px 60px rgba(0,0,0,0.2)",
                  maxWidth: 480,
                  width: "100%",
                  overflow: "hidden",
                }}
                onClick={(e) => e.stopPropagation()}
              >
                {/* Teal header */}
                <div
                  style={{
                    background: accentColor,
                    color: "#fff",
                    padding: "16px 20px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                  }}
                >
                  <h2
                    id="generate-video-kyc-title"
                    style={{ margin: 0, fontSize: "18px", fontWeight: 700, color: "#fff" }}
                  >
                    Generate Video KYC
                  </h2>
                  <button
                    type="button"
                    onClick={closeGenerateKycModal}
                    aria-label="Close"
                    style={{
                      background: "transparent",
                      border: "none",
                      color: "#fff",
                      fontSize: "20px",
                      cursor: "pointer",
                      padding: "0 4px",
                      lineHeight: 1,
                    }}
                  >
                    <i className="fa fa-times" />
                  </button>
                </div>

                <form onSubmit={handleDoKyc} style={{ padding: "20px" }}>
                  <div className="mb-3">
                    <label className="form-label small fw-semibold text-secondary mb-1 d-block">
                      Name :
                    </label>
                    <select
                      value={modalName}
                      onChange={(e) => setModalName(e.target.value)}
                      style={modalInputStyle}
                    >
                      <option value="">Select</option>
                      {SAMPLE_KYC.map((row) => (
                        <option key={row.id} value={row.clientName}>
                          {row.clientName}
                        </option>
                      ))}
                    </select>
                  </div>

                  <div className="row g-3 mb-3">
                    <div className="col-6">
                      <label className="form-label small fw-semibold text-secondary mb-1 d-block">
                        PAN :
                      </label>
                      <input
                        type="text"
                        value={modalPan}
                        onChange={(e) => setModalPan(e.target.value)}
                        style={modalInputStyle}
                        placeholder=""
                      />
                    </div>
                    <div className="col-6">
                      <label className="form-label small fw-semibold text-secondary mb-1 d-block">
                        Mobile :
                      </label>
                      <input
                        type="text"
                        value={modalMobile}
                        onChange={(e) => setModalMobile(e.target.value)}
                        style={modalInputStyle}
                        placeholder=""
                      />
                    </div>
                  </div>

                  <div className="mb-3">
                    <label className="form-label small fw-semibold text-secondary mb-1 d-block">
                      Email :
                    </label>
                    <input
                      type="email"
                      value={modalEmail}
                      onChange={(e) => setModalEmail(e.target.value)}
                      style={modalInputStyle}
                      placeholder=""
                    />
                  </div>

                  <div className="mb-4">
                    <label className="form-label small fw-semibold text-secondary mb-2 d-block">
                      Application Status
                    </label>
                    <div className="d-flex gap-4">
                      <label className="d-flex align-items-center gap-2 mb-0" style={{ cursor: "pointer" }}>
                        <input
                          type="radio"
                          name="modalApplicationStatus"
                          checked={modalApplicationStatus === "new"}
                          onChange={() => setModalApplicationStatus("new")}
                          style={{ accentColor }}
                        />
                        New
                      </label>
                      <label className="d-flex align-items-center gap-2 mb-0" style={{ cursor: "pointer" }}>
                        <input
                          type="radio"
                          name="modalApplicationStatus"
                          checked={modalApplicationStatus === "modified"}
                          onChange={() => setModalApplicationStatus("modified")}
                          style={{ accentColor }}
                        />
                        Modified
                      </label>
                    </div>
                  </div>

                  <div className="text-center">
                    <button
                      type="submit"
                      style={{
                        background: accentColor,
                        color: "#fff",
                        border: "none",
                        padding: "10px 32px",
                        borderRadius: "6px",
                        fontWeight: 600,
                        fontSize: "15px",
                        cursor: "pointer",
                      }}
                    >
                      Do KYC
                    </button>
                  </div>
                </form>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
